import React from "react";
import BuildPackageTicketScreen from "../../../common/AllTickets/BuildPackage/BuildPackageTicketScreen";
function SuperBuildPackageTicket() {
  return <BuildPackageTicketScreen mode="ADMIN" />;
}

export default SuperBuildPackageTicket;
